const EMPLOYMENT_TYPE = Object.freeze({
  employed: 'employed',
  selfEmployed: 'selfEmployed',
});

export default EMPLOYMENT_TYPE;
